module.exports = __webpack_public_path__ + "files/4cbe42616c769acab34d15e643567ec1.png";